import type { IFuseOptions } from "fuse.js";
import type { AutoCombineEntryV2 } from "@/shared/cache";
import type { Entry } from "../normalize";

export const FUSE_OPTIONS: IFuseOptions<Entry> = {
	keys: [
		{ name: "description", weight: 0.5 },
		// Fuse supports dot paths for nested fields.
		{ name: "matter.code", weight: 0.2 },
		{ name: "matter.description", weight: 0.1 },
		{ name: "matter.client", weight: 0.1 },
		{ name: "codes.task", weight: 0.04 },
		{ name: "codes.activity", weight: 0.04 },
		{ name: "application", weight: 0.02 },
	],
	threshold: 0.35,
	ignoreLocation: true,
	minMatchCharLength: 2,
};

// Entry-group search also reaches into the nested source entries so a
// query matches on a source-entry summary or its application even when the
// group's unified narrative doesn't mention it. Fuse indexes arrays of objects
// via dot paths.
export const AUTO_FUSE_OPTIONS: IFuseOptions<AutoCombineEntryV2> = {
	keys: [
		{ name: "description", weight: 0.4 },
		{ name: "matter.code", weight: 0.18 },
		{ name: "matter.description", weight: 0.1 },
		{ name: "matter.client", weight: 0.08 },
		{ name: "codes.task", weight: 0.04 },
		{ name: "codes.activity", weight: 0.04 },
		{ name: "miniTransactions.summary", weight: 0.12 },
		{ name: "miniTransactions.canonicalName", weight: 0.06 },
		{ name: "miniTransactions.application", weight: 0.04 },
	],
	threshold: 0.35,
	ignoreLocation: true,
	minMatchCharLength: 2,
};
